"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.VideoSchema = exports.videoBackgroundProperties = void 0;
var yup = __importStar(require("yup"));
var schemaUtils_1 = require("../schemaUtils");
var Image_schema_1 = require("../image/Image.schema");
var ImageMask_schema_1 = require("../image/ImageMask.schema");
exports.videoBackgroundProperties = yup.object({
    enableBackgroundVideo: yup.boolean().meta({
        description: 'sets the component ability to play its background video on mobile',
    }),
});
exports.VideoSchema = schemaUtils_1.createDataSchema('WixVideo', yup.object({
    title: yup.string().max(100),
    alt: yup
        .string()
        .max(1000)
        .notRequired(),
    videoId: yup.string(),
    generatedPosters: yup.array().of(yup.string()),
    qualities: yup.array().of(yup.object({
        quality: yup.string(),
        width: yup.number(),
        height: yup.number(),
        formats: yup
            .array()
            .of(yup.string())
            .notRequired()
            .meta({
            description: "Deprecated, replaced by 'format' and 'url' since we have a unique url for each quality",
        }),
        format: yup
            .mixed()
            .oneOf(['mp4', 'webm'])
            .default('mp4'),
        url: yup.string(),
    })),
    adaptiveVideo: yup
        .array()
        .of(yup.object({
        format: yup
            .mixed()
            .oneOf(['hls', 'dash'])
            .default('hls'),
        url: yup.string(),
    }))
        .notRequired(),
    posterImageRef: schemaUtils_1.createDataRef({ Image: Image_schema_1.ImageSchema }).nullable(),
    duration: yup.number(),
    fps: yup.string().max(50),
    hasAudio: yup.boolean().meta({ description: 'video has no audio' }),
    artist: yup.object({ name: yup.string(), id: yup.string() }),
    loop: yup.boolean(),
    autoplay: yup.boolean(),
    playbackSpeed: yup.number(),
    preload: yup
        .mixed()
        .oneOf(['auto', 'metadata', 'none'])
        .default('none'),
    controls: yup
        .mixed()
        .oneOf(['none', 'full'])
        .default('none'),
    mute: yup
        .boolean()
        .meta({ description: 'deprecated, moved to properties' }),
    opacity: yup.number(),
    mediaFeatures: yup
        .array()
        .of(yup
        .mixed()
        .oneOf(['alpha', '360'])
        .notRequired())
        .default([]),
    mask: ImageMask_schema_1.ImageMaskSchema.notRequired().nullable(),
}));
//# sourceMappingURL=Video.schema.js.map